<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>
      <template v-slot:foot="{ items }">
        <template v-if="items.length > 0">
          <td colspan="2" class="font-weight-bold">Totales</td>

          <td></td>

          <td class="text-right font-weight-bold">
            {{ items.reduce((acumulado, asesor) => acumulado + asesor.totalInscripcionesNoCumplenRequisitos, 0) }}
          </td>

          <td class="text-right font-weight-bold">
            {{ items.reduce((acumulado, asesor) => acumulado + asesor.totalInscripcionesCumplenRequisitos, 0) }}
          </td>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TablaInscripcionesCompletasPorAsesores',
  props: {
    inscripcionesPorAsesores: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items: function () {
      const items = this.inscripcionesPorAsesores.map((incripcionPorAsesor, index) => {
        return {
          nro: index + 1,
          ...incripcionPorAsesor,
        };
      });

      return items;
    },
  },
  data() {
    return {
      headers: [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'nro',
        },
        {
          text: 'Número de Documento',
          align: 'start',
          sortable: true,
          value: 'numeroDocumentoAsesor',
        },
        {
          text: 'Nombre Completo',
          align: 'start',
          sortable: true,
          value: 'nombreCompletoAsesor',
        },
        {
          text: 'Total No Cumple Requisitos',
          align: 'end',
          sortable: true,
          value: 'totalInscripcionesNoCumplenRequisitos',
        },
        {
          text: 'Total Cumple Requisitos',
          align: 'end',
          sortable: true,
          value: 'totalInscripcionesCumplenRequisitos',
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>